export const uiConfigId = "uet-university-397860"